<div
  *ngIf="!buttonMode; else buttonView"
  style="cursor: pointer"
  p500UITooltip
  [class]="'d-block text-center p500-ui-icon-' + (crmType === 'advertiser' ? 'logo-AD' : 'logo-AA')"
  [ngClass]="customClass"
  [tooltipData]="crmData.tooltip"
  [ngStyle]="disabled ? { opacity: 0.3, cursor: 'default' } : {}"
  (click)="authAs()"
></div>
<ng-template #buttonView>
  <button p500-ui-button color="primary" classIcon="p500-ui-icon-log-in" [ngClass]="customClass" (click)="authAs()">
    <ng-container [ngSwitch]="crmType">
      <ng-container *ngSwitchCase="'affiliate'" i18n="@@affiliate.area">Affiliate Area</ng-container>
      <ng-container *ngSwitchCase="'advertiser'" i18n="@@advertiser.area">Advertiser Area</ng-container>
    </ng-container>
  </button>
</ng-template>
